import { useEffect } from "react"
import { useParams } from "react-router-dom"
import { useDispatch, useSelector } from 'react-redux'
import { fetchDataDetailAmiboCharacter} from '../Store/actions'

export default function Detail () {
  let { tail } = useParams()
  const dispatch = useDispatch()
  const detailCharacter = useSelector(state => state.detailAmibo.dataDetailAmibo)
  useEffect(() => {
    dispatch(fetchDataDetailAmiboCharacter(tail))
  }, [tail, dispatch])
  
  if(detailCharacter.release) {
    return (
      <div>
        <h1 className="m-4" style={{textAlign: "center", fontFamily: "Roboto", fontSize: 68}}>{detailCharacter.name}</h1>
        <div className="container" style={{display: "flex", justifyContent: "space-evenly"}}>
          <img src={detailCharacter.image} alt="Mario" style={{height: 460, width: 320}}></img>
          <div>
            <p style={{fontSize: 19, color: "grey"}}>Amiibo Series: </p>
            <h2>{detailCharacter.amiiboSeries}</h2>
            <p style={{fontSize: 19, color: "grey"}}>Game Series: </p>
            <h2>{detailCharacter.gameSeries}</h2>
            <p style={{fontSize: 19, color: "grey"}}>Character: </p>
            <h2> {detailCharacter.character}</h2>
            <p style={{fontSize: 19, color: "grey"}}>Type: </p>
            <h2> {detailCharacter.type}</h2>
            <p style={{fontSize: 19, color: "grey"}}>Release Date: </p>
            <h2> {detailCharacter.release.na}</h2>
          </div>
        </div>
      </div>
    )
  }
  return (
    <div>
      <h1 className="m-4" style={{textAlign: "center", fontFamily: "Roboto", fontSize: 68}}>{detailCharacter.name}</h1>
      <div className="container" style={{display: "flex", justifyContent: "space-evenly"}}>
        <img src={detailCharacter.image} alt="Mario" style={{height: 460, width: 320}}></img>
        <div>
          <p style={{fontSize: 19, color: "grey"}}>Amiibo Series: </p>
          <h2>{detailCharacter.amiiboSeries}</h2>
          <p style={{fontSize: 19, color: "grey"}}>Game Series: </p>
          <h2>{detailCharacter.gameSeries}</h2>
          <p style={{fontSize: 19, color: "grey"}}>Character: </p>
          <h2> {detailCharacter.character}</h2>
          <p style={{fontSize: 19, color: "grey"}}>Type: </p>
          <h2> {detailCharacter.type}</h2>
        </div>
      </div>
    </div>
  )
}

